<div #step1 class="ui-g">

  <div class="ui-g-12 ui-lg-6 campaign-card-pad">
    <div class="card left">
      <div class="ui-g form-group">

        <div class="ui-g-12">
          <h1 class="campaign-step">{{ 'campaign.selectBusinessGoal' | translate }}</h1>
        </div>

        <div class="ui-g-12" *ngFor="let goal of goals; let i = index;">
          <button pButton type="button" class="ButtonCampaign" icon="{{ goalIcons[i] }} fa-2x" iconPos="left" label="{{ goal.focusName }}" [ngClass]="{ 'active': campaign.goalId == goal.focusId }" (click)="setGoal(goal.focusId)"></button>
        </div>

      </div>
    </div>
  </div>

  <div class="ui-g-12 ui-lg-6 campaign-card-pad">
    <div class="card right" *ngIf="campaign.goalId && goals.length > 0">

      <div class="ui-g form-group" *ngFor="let goal of goals;">
        <div *ngIf="campaign.goalId == goal.focusId">
          <div class="ui-g-12">
            <h1 class="campaign-step">{{ 'campaign.selectActivity' | translate }}</h1>
          </div>
          <div class="ui-g-12" *ngFor="let target of goal.targetModel">
            <button pButton type="button" class="activity" [ngClass]="{ 'active': campaign.targetId == target.targetCode }" label="{{ target.targetName }}" (click)="setTarget(target.targetCode)"></button>
          </div>
        </div>
      </div>

    </div>
  </div>

</div>



// WEBPACK FOOTER //
// ./src/app/views/campaign/new-campaign/step-1/campaign-step-1.html